import { render } from "./FirstView011.vue?vue&type=template&id=6f767488&scoped=true"
const script = {}

import "./FirstView011.vue?vue&type=style&index=0&id=6f767488&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f767488"]])

export default __exports__